import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import * as url from "url";

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  public selectedRating = 0;
  public selectedChoiceIndex = -1;
  public starsArray: number[] = Array(5).fill(0).map(_ => 0); // Tutte le stelle inizializzate a 0
  url = "services/portaleamministrazione/api"

  constructor(private httpClient: HttpClient) {}

  salvaFeedback(feedback: any): Observable<void>{
    return this.httpClient.post<void>(this.url + '/feedback/salva', feedback)
  }

  resetArray(): void {
    this.selectedRating = 0;
    this.starsArray = Array(5).fill(0); // Resetta l'array delle stelle
  }
}
